export default function Input() {
  return {
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontWeight: 500,
          fontSize: "16px",
          lineHeight: "24px",
          padding: "12px !important",
        },
        inputSizeSmall: {
          padding: "8.5px 12px !important",
        },
      },
    },
  };
}
